import { Box, FormControl, Grid, InputLabel, MenuItem, OutlinedInput, Select, TextField, Typography } from '@mui/material'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import React from 'react'
import { Time } from '../../Helper/Time'
import { AllWeekType, WeekLongString, WeekType } from '../../Helper/Week'
import TimeRangeInput from '../atoms/TimeRangeInput'

export interface LessonReservableInputFormProps {
    week?: WeekType | null
    startApply?: Date | null
    endApply?: Date | null
    startTime: Time | null
    endTime: Time | null
    timeRangeFrom: Time
    timeRangeTo: Time
    timeRangeUnit: number
    onChange: (week: WeekType | null | undefined, startApply: Date | null | undefined, endApply: Date | null | undefined, start: Time | null, end: Time | null) => void
    lrvableId?: number
}

const LessonReservableInputForm: React.FC<LessonReservableInputFormProps> = ({
    week,
    startApply,
    endApply,
    startTime,
    endTime,
    timeRangeFrom,
    timeRangeTo,
    timeRangeUnit,
    onChange,
    lrvableId,
}) => {
    return (
        <Box
        >
            <Grid
                container
                alignItems="center"
                spacing={5}
            >
                {lrvableId &&
                    <Grid item>
                        <Typography>[{lrvableId}]</Typography>
                    </Grid>
                }
                <Grid item xs>
                    <FormControl
                        fullWidth
                        size='small'
                    >
                        <InputLabel id='week-select-label'>曜日を選択</InputLabel>
                        <Select
                            labelId='week-select-label'
                            value={week ? week : ''}
                            onChange={e => {
                                onChange(e.target.value as WeekType, startApply, endApply, startTime, endTime)
                            }}
                            input={<OutlinedInput label='曜日を選択' />}
                        >
                            <MenuItem value='' disabled />
                            {AllWeekType.map(wk => <MenuItem value={wk} key={wk}>{WeekLongString[wk]}</MenuItem>)}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={5}>
                    <TimeRangeInput
                        onChange={(start: Time | null, end: Time | null) => {
                            onChange(week, startApply, endApply, start, end)
                        }}
                        startTime={startTime}
                        endTime={endTime}
                        from={timeRangeFrom}
                        to={timeRangeTo}
                        unit={timeRangeUnit}
                        disableClear
                    />
                </Grid>
                <Grid item xs={2}>
                    <DatePicker
                        label="適用開始日"
                        onChange={date => {
                            onChange(week, date, endApply, startTime, endTime)
                        }}
                        value={startApply ? startApply : null}
                        renderInput={params => <TextField {...params} size="small" />}
                        inputFormat="yyyy/MM/dd"
                        mask="____/__/__"
                        clearable={true}
                        defaultCalendarMonth={null}

                    />
                </Grid>
                <Grid item xs={2}>
                    <DatePicker
                        label="適用終了日"
                        onChange={date => {
                            onChange(week, startApply, date, startTime, endTime)
                        }}
                        value={endApply ? endApply : null}
                        renderInput={params => <TextField {...params} size="small" />}
                        inputFormat="yyyy/MM/dd"
                        mask="____/__/__"
                        clearable={true}
                        defaultCalendarMonth={null}
                    />
                </Grid>
            </Grid>
        </Box>
    )
}

export default LessonReservableInputForm